var stickyNav = {
	bodyElement: {},
	headerElement: {},
	headerElementY: {},
	headerTopElement: {},
	headerTopElementY: {},
	navElement: {},
	navElementY: {},
	navStickpoint: 0,
	figureElement: {},
	firgureElementY: {},
	infoStripElement: {},
	infoStripElementY: {},
	infoStripStickPoint: 0,
	isNavStuck: false,
	isInfoStripStuck: false,

	setup: function(){
		stickyNav.bodyElement = $('body');
		stickyNav.headerElement = $('header.header');
		stickyNav.headerElementY = stickyNav.headerElement.outerHeight();
		stickyNav.headerTopElement = $('header.header div.row:first-child');
		stickyNav.headerTopElementY = stickyNav.headerTopElement.outerHeight();
		stickyNav.navElement = $('header.header nav.header-nav');
		stickyNav.navElementY = stickyNav.navElement.outerHeight();
		stickyNav.figureElement = $('.single-head figure, .single-head img');
		stickyNav.figureElementY = stickyNav.figureElement.outerHeight();
		stickyNav.infoStripElement = $('.single-head .info-strip');
		stickyNav.infoStripElementY = stickyNav.infoStripElement.outerHeight();
		// Reset position before we get the offset top
		stickyNav.headerElement.css('top', 0);
		stickyNav.bodyElement.css('padding-top', 0);
		stickyNav.headerElement.removeClass('nav-lock');
		stickyNav.infoStripElement.removeClass('nav-lock');
		stickyNav.navStickpoint = stickyNav.navElement.offset().top;
		stickyNav.infoStripStickPoint = stickyNav.navElementY;
	},
	init: function () {
		stickyNav.setup();
		stickyNav.stickyScroller();
		window.onscroll = function() {
			stickyNav.stickyScroller();
		}
		window.onresize = function() {
			stickyNav.setup();
			if (window.pageYOffset >= stickyNav.navStickpoint) {
				stickyNav.isInfoStripStuck = false;
			}
			stickyNav.stickyScroller();
		}
	},
	stickyScroller: function(){
		if (window.pageYOffset >= stickyNav.navStickpoint && !stickyNav.isInfoStripStuck) {
			stickyNav.headerElement.css('top', stickyNav.headerTopElementY*-1);
			stickyNav.headerElement.addClass('nav-lock');
			stickyNav.bodyElement.css('padding-top', stickyNav.headerElementY);

			stickyNav.isNavStuck = true;
		}
		if (window.pageYOffset >= stickyNav.headerElementY + stickyNav.figureElementY - stickyNav.navElementY && stickyNav.isNavStuck) {
			stickyNav.infoStripElement.css('top', stickyNav.infoStripStickPoint);
			stickyNav.bodyElement.css('padding-top', (stickyNav.navElementY + stickyNav.headerElementY));
			stickyNav.infoStripElement.addClass('nav-lock');

			stickyNav.isInfoStripStuck = true;
		}
		if (window.pageYOffset < stickyNav.headerElementY + stickyNav.figureElementY - stickyNav.navElementY && stickyNav.isNavStuck){
			stickyNav.infoStripElement.css('top', 'unset');
			stickyNav.infoStripElement.removeClass('nav-lock');
			stickyNav.bodyElement.css('padding-top', stickyNav.headerElementY);

			stickyNav.isInfoStripStuck = false;
		}
		if (window.pageYOffset < stickyNav.navStickpoint && !stickyNav.isInfoStripStuck){
			stickyNav.headerElement.css('top', 0);
			stickyNav.headerElement.removeClass('nav-lock');
			stickyNav.bodyElement.css('padding-top', 0);

			stickyNav.isNavStuck = false;
		}
	}
}
module.exports = stickyNav;